/* 该元素自适应最大高度 */

/* 元素上边距 */
function elementToTop(el) {
	let elementScrollTop = 0;
	let currentOffsetParent = el.offsetParent;
	let currentOffsetTop = el.offsetTop;
	while (currentOffsetParent != null) {
		currentOffsetTop += currentOffsetParent.offsetTop;
		currentOffsetParent = currentOffsetParent.offsetParent;
	}
	if (document.compatMode == 'BackCompat') {
		elementScrollTop = document.body.scrollTop;
	} else {
		elementScrollTop = document.documentElement.scrollTop;
	}
	return (currentOffsetTop - elementScrollTop);
}

/* 元素下方元素高度 */

export default function responsiveMaxHeight(bottomHeightValue = 0, el) {
	const windowHeight = window.innerHeight;
	const elementToTopNum = elementToTop(el);
	const remainSpaceHeight = 67;

	return (windowHeight - elementToTopNum - bottomHeightValue - remainSpaceHeight) <= 315 ? 315 : (windowHeight - elementToTopNum - bottomHeightValue - remainSpaceHeight);
}
